import { AdminState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    adminUsers: (state: AdminState) => state.users,
    adminOneUser: (state: AdminState) => (userId: number) => {
        const filteredUsers = state.users.filter((user) => user.id === userId);
        if (filteredUsers.length > 0) {
            return { ...filteredUsers[0] };
        }
    },
    adminOneAccount: (state: AdminState) => (accountId: number) => {
        const filteredAccounts = state.accounts.filter((account) => account.id === accountId);
        if (filteredAccounts.length > 0) {
            return { ...filteredAccounts[0] };
        }
    },
    adminRoles: (state: AdminState) => state.roles,
    adminLanguages: (state: AdminState) => state.languages,
    adminSystemFeatures: (state: AdminState) => state.systemFeatures,
    adminActions: (state: AdminState) => state.actions,
    adminCurrencies: (state: AdminState) => state.currencies,
    adminCountries: (state: AdminState) => state.countries,
    adminCities: (state: AdminState) => state.cities,
    adminStates: (state: AdminState) => state.states,
    adminAccountProfiles: (state: AdminState) => state.accountProfiles,
    adminAccounts: (state: AdminState) => state.accounts,
    adminSponsors: (state: AdminState) => state.sponsors,
    adminOneSponsor: (state: AdminState) => (sponsorId: number) => {
        const filteredSponsors = state.sponsors.filter((sponsor) => sponsor.id === sponsorId);
        if (filteredSponsors.length > 0) {
            return { ...filteredSponsors[0] };
        }
    }
};

const { read } = getStoreAccessors<AdminState, State>('');

export const readAdminOneUser = read(getters.adminOneUser);
export const readAdminUsers = read(getters.adminUsers);

export const readAdminRoles = read(getters.adminRoles);
export const readAdminLanguages = read(getters.adminLanguages);
export const readAdminSystemFeatures = read(getters.adminSystemFeatures);
export const readAdminActions = read(getters.adminActions);
export const readAdminCurrencies = read(getters.adminCurrencies);
export const readAdminCountries = read(getters.adminCountries);
export const readAdminStates = read(getters.adminStates);
export const readAdminCities = read(getters.adminCities);
export const readAdminAccountProfiles = read(getters.adminAccountProfiles);
export const readAdminAccounts = read(getters.adminAccounts);
export const readAdminOneAccount = read(getters.adminOneAccount);
export const readAdminSponsors = read(getters.adminSponsors);
export const readAdminOneSponsor = read(getters.adminOneSponsor);